module.exports = __webpack_public_path__ + "static/media/kela-696x408.da8cd2d5.png";